import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Info, X } from 'lucide-react';

const DISMISS_KEY = 'trove.betaPricingNoticeDismissed';

/**
 * Public-beta notice: all tiers free today; GA follows plan matrix.
 * Dismissible per browser (localStorage).
 */
export function BetaPricingBanner() {
  const { t } = useTranslation('settings');
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      setVisible(window.localStorage.getItem(DISMISS_KEY) !== '1');
    } catch {
      setVisible(true);
    }
  }, []);

  if (!visible) return null;

  return (
    <div
      role="status"
      className="flex shrink-0 items-center justify-center gap-2 border-b border-sky-500/30 bg-sky-950/90 px-3 py-2 text-center text-xs font-medium text-sky-50 sm:text-sm"
    >
      <Info className="hidden h-4 w-4 shrink-0 sm:inline" aria-hidden />
      <span className="min-w-0 flex-1">{t('subscription.betaNotice')}</span>
      <Link to="/settings/subscription" className="shrink-0 underline underline-offset-2 hover:opacity-90">
        {t('subscription.betaNoticeLink')}
      </Link>
      <button
        type="button"
        onClick={() => {
          try {
            window.localStorage.setItem(DISMISS_KEY, '1');
          } catch {
            /* ignore */
          }
          setVisible(false);
        }}
        className="shrink-0 rounded p-1 hover:bg-sky-800/50"
        aria-label={t('subscription.betaNoticeDismiss')}
      >
        <X className="h-4 w-4" aria-hidden />
      </button>
    </div>
  );
}
